export * from './post-objekt-art-request.interface';
export * from './post-objekt-art-response.interface';
export * from './post-objekt-art.shapes';
